import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import { ContentLoader } from '@saucelabs/sl-component-loader';

import { operations } from './../ducks/container';
import FormTitle from './../components/FormTitle';

class VerifyUserContainer extends Component {
  componentDidMount() {
    const { authenticated, verifyUser, queryParams } = this.props;

    if (queryParams?.token) {
      verifyUser({ authenticated, queryParams });
    }
  }

  render() {
    const { authenticated, locationState } = this.props;
    const targetPage = authenticated ? 'onboarding' : 'login';

    return (
      <ContentLoader show={!locationState}>
        <div>
          <FormTitle>Thank you for verifying your email address.</FormTitle>
          <div>
            <p>
              In a moment you will be redirected to the Sauce Labs
              {targetPage}
              page.
            </p>
            <p>Happy testing!</p>
          </div>
        </div>
      </ContentLoader>
    );
  }
}

const mapStateToProps = ({ user }, { location: { state, search } }) => ({
  authenticated: user?.isAuthenticated(),
  locationState: state,
  queryParams: qs.parse(search, { ignoreQueryPrefix: true }),
});

const mapDispatchToProps = {
  verifyUser: operations.verifyUser,
};

VerifyUserContainer.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  locationState: PropTypes.object,
  queryParams: PropTypes.object,
  verifyUser: PropTypes.func.isRequired,
};

VerifyUserContainer.defaultProps = {
  locationState: null,
  queryParams: {},
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyUserContainer));
export { VerifyUserContainer, mapDispatchToProps };
